import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icons-close-8ddcf",
  "use": "icons-close-8ddcf-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icons-close-8ddcf\"><path fill-rule=\"evenodd\" d=\"m10.232 12-9.116 9.116 1.768 1.768L12 13.768l9.116 9.116 1.768-1.768L13.768 12l9.116-9.116-1.768-1.768L12 10.232 2.884 1.116 1.116 2.884z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol